// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIGREl2kwv1POdGT6ip9W8jxhWRqQAmTE",
  authDomain: "scoreholio.firebaseapp.com",
  databaseURL: "https://scoreholio.firebaseio.com",
  projectId: "scoreholio",
  storageBucket: "scoreholio.appspot.com",
  messagingSenderId: "113741626167",
  appId: "1:113741626167:web:29bc6a551f56c69f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// SCO-2267: Firestore's WebChannel transport hits its internal "Unexpected
// state" hardAssert on the overlay's long-lived watch streams inside OBS/CEF.
// Auto-detect long polling is already the SDK default (v9.22.0+) and never engages
// in CEF (its buffering-proxy probe doesn't fire), so force long polling on
// the overlay route only (/v2/<sport>/overlay — same idiom as App.jsx's
// isOverlay). The two flags are mutually exclusive, so everywhere else passes
// no flags and keeps the default auto-detect WebChannel transport.
export const db = initializeFirestore(
  app,
  window.location.pathname.split("/")[3] === "overlay"
    ? { experimentalForceLongPolling: true }
    : {}
);
// SCO-2066: initializeAuth WITHOUT a popupRedirectResolver. getAuth() wires in
// browserPopupRedirectResolver, which on mobile UAs proactively loads Google's
// hidden auth iframe at startup and rejects unhandled with
// auth/network-request-failed when the network drops — and the app never uses
// popup/redirect sign-in at all. The persistence list matches getAuth()'s
// defaults in exactly this order so existing sessions keep working.
const auth = initializeAuth(app, {
  persistence: [
    indexedDBLocalPersistence,
    browserLocalPersistence,
    browserSessionPersistence,
  ],
});
export { auth, app };
